import { CmsComponents } from '@seven1/angular-storyblok/api';
import { GroupComponent } from '@seven1/angular-storyblok-components/group';

import {
    GridFiveColumnComponent,
    GridFourColumnComponent,
    GridOneColumnComponent,
    GridThreeColumnComponent,
    GridTwoColumnComponent
} from '@seven1/angular-storyblok-components/grid';

import { PageComponent } from '../app/cms/components/layout/page';
import { HeroSectionContainerComponent } from '../app/cms/components/layout/hero-section';
import { DecoratedSectionContainerComponent } from '../app/cms/components/layout/decorated-section';
import { FooterComponent } from '../app/cms/components/layout/footer';
import { InnerStyledHeadingComponent } from '../app/cms/components/reusable/inner-styled-heading';
import { NavGroupComponent } from '../app/cms/components/layout/navigation/nav-group';
import { SectionContainerComponent } from '../app/cms/components/layout/section';
import { OneDirectionContainerComponent } from '../app/cms/components/layout/one-direction-container';
import { ImageListElementComponent } from '../app/cms/components/reusable/image-list-element';
import { IconComponent } from '../app/cms/components/reusable/icon';
import { CardWithIconComponent } from '../app/cms/components/reusable/card-with-icon';
import { ButtonComponent } from '../app/cms/components/reusable/button';
import { InfoComponent } from '../app/cms/components/reusable/info';
import { ButtonWithDotComponent } from '../app/cms/components/reusable/button-with-dot';
import { TariffEntry, TariffOrderButtonComponent, TariffSection, TariffTable } from '../app/cms/components/specific/tariff';
import { TariffToggleComponent } from '../app/cms/components/specific/tariff-toggle';
import { IframeComponent } from '../app/cms/components/reusable/iframe';
import { PriceColumnComponent } from '../app/cms/components/specific/price-column';
import { ButtonDecoratedTextComponent } from '../app/cms/components/reusable/button-decorated-text';
import { TariffButtonComponent } from '../app/cms/components/specific/tariff-button';
import { InfoButtonComponent } from '../app/cms/components/specific/info-button';
import { ImageComponent } from '@seven1/angular-storyblok-components/image';
import { LinkComponent, ScrollLinkComponent } from '@seven1/angular-storyblok-components/cta';
import { FaqComponent, FaqItemComponent } from '@seven1/angular-storyblok-components/faq';
import { HtmlComponent } from '@seven1/angular-storyblok-components/html';
import { VideoComponent } from '@seven1/angular-storyblok-components/video';
import { HeadlineComponent, ParagraphComponent, RichTextComponent } from '@seven1/angular-storyblok-components/text';
import { CoverComponent } from '@seven1/angular-storyblok-components/cover';
import { FooterRecruitComponent } from '@seven1/angular-storyblok-components/footer-recruit';
import { RedirectComponent } from '../app/cms/components/layout/redirect';
import { BlogArticlesList, BlogArticlesView } from '@seven1/angular-storyblok-components/blog';
import { QuoteboxComponent } from '@seven1/angular-storyblok-components/quotebox';
import { ImportantInfoComponent } from '@seven1/angular-storyblok-components/important-info';
import { TableComponent } from '@seven1/angular-storyblok-components/table';
import { SeparationLineComponent } from '@seven1/angular-storyblok-components/separation-line';
import { CmsLayoutComponent } from '../app/cms/components/layout/cms-layout';
import { QuoteComponent } from '@seven1/angular-storyblok-components/quote';
import { TariffOptionCardComponent, TariffOptionCardsComponent } from '../app/cms/components/specific/option-cards';
import { ListComponent, ListElementComponent } from '../app/cms/components/reusable/list';
import { TrustpilotComponent } from '@seven1/angular-storyblok-components/trustpilot';

export const APP_COMPONENTS: CmsComponents = {
    sy_page: PageComponent,
    sy_maintenance_page: PageComponent,
    sy_layout: CmsLayoutComponent,
    sy_footer: FooterComponent,
    sy_nav_group: NavGroupComponent,
    sy_section: SectionContainerComponent,
    sy_decoratedSection: DecoratedSectionContainerComponent,
    sy_group: GroupComponent,
    sy_one_direction_container: OneDirectionContainerComponent,
    sy_grid_one_column: GridOneColumnComponent,
    sy_grid_two_column: GridTwoColumnComponent,
    sy_grid_three_column: GridThreeColumnComponent,
    sy_grid_four_column: GridFourColumnComponent,
    sy_grid_five_column: GridFiveColumnComponent,
    redirects_page: PageComponent,
    redirect: RedirectComponent,
    heading: HeadlineComponent,
    paragraph: ParagraphComponent,
    richtext: RichTextComponent,
    separationLine: SeparationLineComponent,
    link: LinkComponent,
    scrollLink: ScrollLinkComponent,
    image: ImageComponent,
    faq: FaqComponent,
    faqItem: FaqItemComponent,
    video: VideoComponent,
    html: HtmlComponent,
    cover: CoverComponent,
    sy_innerStyledHeading: InnerStyledHeadingComponent,
    footerRecruit: FooterRecruitComponent,
    sy_tarifHelpButton: InfoButtonComponent,
    sy_iconListElementWithDescription: ImageListElementComponent,
    sy_tarifButton: TariffButtonComponent,
    sy_tariffTable: TariffTable,
    sy_tariffSection: TariffSection,
    sy_tariffEntry: TariffEntry,
    sy_tarifOrderButton: TariffOrderButtonComponent,
    sy_icon: IconComponent,
    sy_tarifToggle: TariffToggleComponent,
    sy_button: ButtonComponent,
    sy_iframe: IframeComponent,
    sy_buttonDecoratedText: ButtonDecoratedTextComponent,
    sy_info: InfoComponent,
    sy_buttonWithDot: ButtonWithDotComponent,
    sy_iconCard: CardWithIconComponent,
    sy_heroSection: HeroSectionContainerComponent,
    sy_priceColumn: PriceColumnComponent,
    sy_quotebox: QuoteboxComponent,
    sy_importantInfo: ImportantInfoComponent,
    sy_quote: QuoteComponent,

    // table
    table: TableComponent,

    // Blog
    sy_BlogArticleList: BlogArticlesList,
    sy_BlogArticles: BlogArticlesView,

    sy_tariff_option_cards: TariffOptionCardsComponent,
    sy_tariff_option_card: TariffOptionCardComponent,

    sy_list: ListComponent,
    sy_listElement: ListElementComponent,
    trustpilot: TrustpilotComponent,
};
